import type { CancelMedicationItemType } from '@/components/PatientPageV2/components/PrescriptionPad';
import type { StateCreator } from 'zustand';
import type { PrescriptionAssistantSliceType } from '../types';

export const updatePrescriptionHistoryItemsToCancel: StateCreator<
  PrescriptionAssistantSliceType,
  [['zustand/immer', never], ['zustand/devtools', never]],
  [],
  (itemsToCancel: CancelMedicationItemType[]) => void
> = (set) => (itemsToCancel) =>
  set(
    (state: PrescriptionAssistantSliceType) => {
      state.prescriptionAssistant.prescriptionHistory.itemsToCancel = itemsToCancel;
    },
    false,
    'prescriptionHistory/updatePrescriptionHistoryItemsToCancel'
  );
